import { ACHIEVEMENT_USER_LEVELS } from 'constants/user/userLevels'
import { AchievementCSS } from './AchievementCSS.styled'
import { currencyFormatter } from 'utils'
import { Helmet } from 'react-helmet'
import { useScrollTo } from 'hooks/useScrollTo'
import { useUserAchievementData } from './useUserAchievementData'
import { SingleDataLoader } from 'components/Atoms/SingleDataLoader'
import { GoalTableRow } from './GoalTableRow'
import { LevelTableRow } from './LevelTableRow'
import { UserAchievementInfo } from './UserAchievementInfo'

export const Achievement = () => {
  const { loading, achievementList, achievementUser, achievementsLevel } = useUserAchievementData()

  const { scrollRef: tiersRef, scrollToRef: scrollToTiersRef } = useScrollTo()
  return (
    <AchievementCSS>
      <Helmet>
        <title>YOLOREKT | ACHIEVEMENTS</title>
      </Helmet>
      <div className='scroll_wrapper'>
        <div className='achievements_page_wrapper'>
          <h1>Achievements</h1>
          <h2>Earn your status on YOLOREKT by completing tasks and achievements, and earn more rewards.</h2>

          {/* Personal Achievement info */}
          <h3>Your achievement status:</h3>
          <UserAchievementInfo
            loading={loading}
            achievementUser={achievementUser}
            scrollToTiersRef={scrollToTiersRef}
          />
          {/* Personal Achievement info */}

          <div className='achievements_table_wrapper'>
            <h3>
              Goals <SingleDataLoader loading={loading} />
            </h3>
            <div className='grid-body your_bids_iw'>
              <div className='grid-header'>
                <label className='done'></label>
                <label className='tier'>Name</label>
                <label>Achievement</label>
                <label>Reward</label>
                <label>Difficulty</label>
              </div>
              <div className='grid-content'>
                {!loading && achievementList.map((goalRow, idx) => <GoalTableRow key={`goal${idx}`} row={goalRow} />)}
              </div>
            </div>
          </div>
          <div className='tiers_table_wrapper'>
            <h3 ref={tiersRef}>
              Levels <SingleDataLoader loading={loading} />
            </h3>
            <div className='grid-body your_bids_iw'>
              <div className='grid-header'>
                <label className='tier_level'></label>
                <label>Tier</label>
                <label>XP Requirement</label>
                <label>Reward</label>
              </div>

              <div className='grid-content'>
                {!loading &&
                  achievementsLevel.map((level, idx) => (
                    <LevelTableRow key={`level${idx}`} level={level} id={idx + 1} achievementUser={achievementUser} />
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AchievementCSS>
  )
}
